import initWrapper from 'client/shared/init-wrapper'

import store from 'shared/stores/bookmate-store'
import routes from 'shared/routes/bookmate-routes'

initWrapper.init({ store, routes })
